import { DialogTitle, GridProps, useTheme } from '@mui/material';
import { ContextForm, IFormAfterSubmit, InputOnlyField, Select, Text } from '@ngt/forms';
import { ValidateOn } from '@ngt/forms-core';
import { FC, useCallback, useContext } from 'react';
import { Project } from '../api/dtos';
import { FormSection, IFormDialogProps, StyledButton, StyledDialog, StyledDialogActions, StyledDialogContent, StyledFormColumn, StyledFormSubmitButton } from './inputs/CommonFormElements';
import LotPropertiesContext from '../contexts/LotPropertiesContext';
import LotChangesContext from '../contexts/LotChangesContext';

const COLUMN_SIZING: GridProps['size'] = {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
} 

const LotForm: FC<IFormDialogProps> = (props) => {
    const theme = useTheme();
    const { refresh: refreshLotProperties } = useContext(LotPropertiesContext);
    const { refresh: refreshLotChanges } = useContext(LotChangesContext);

    const onAfterSubmit: IFormAfterSubmit<Project> = useCallback(async (_newValue, _formState, _formActions) => {
        await refreshLotProperties();
        await refreshLotChanges();
        props.onClose();
    }, [refreshLotProperties, refreshLotChanges, props.onClose])

    return (
        <ContextForm
            onAfterSubmit={onAfterSubmit}
            validateOn={ValidateOn.onChange}
            validateOnReset
        >
            <StyledDialog {...props}>
                <DialogTitle
                    sx={{
                        backgroundColor: theme.palette.secondary.light,
                        color: "white"
                    }}
                >
                    {props.edit ? "Edit" : "Add"} Lot Property
                </DialogTitle>
                <StyledDialogContent>
                    <FormSection>
                        <StyledFormColumn
                            size={COLUMN_SIZING}
                        >
                            <InputOnlyField 
                                label={'Property'}
                                component={Select}
                                propertyPath={'propertyId'}
                            />
                            <InputOnlyField 
                                label={'Value'}
                                component={Text}
                                propertyPath={'value'}
                            />
                        </StyledFormColumn>
                    </FormSection>
                </StyledDialogContent>
                <StyledDialogActions>
                    <StyledFormSubmitButton variant="contained">Submit</StyledFormSubmitButton>
                    <StyledButton variant="contained" onClick={props.onClose}>Cancel</StyledButton>
                </StyledDialogActions>
            </StyledDialog>
        </ContextForm>
    );
}

export default LotForm;